<template>
  <th
    :title="hoverTitle"
    class="hover: cursor-pointer rounded-8 whitespace-nowrap px-4 text-14"
    @click="sortingActivated"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div v-if="sortby != ''" class="w-8 inline-block mr-4">
      <Sorting v-show="hover || activeSorting" :enabled="activeSorting" :ascending="ascending" />
    </div>
    <span v-text="title" />
    <span
      title="Warning: Results may be invalid due to a corrupted or incomplete input file."
      v-if="isComputedData && isVolumeInvalid"
      class="px-2 text-red-500"
      ><i class="fa-solid fa-circle-exclamation"
    /></span>
  </th>
</template>

<script lang="ts">
import { mapState } from 'vuex';
import Sorting from '@/components/Reusable/Sorting.vue';

type ComputedData = 'Cost' | 'Price' | 'Lead Time' | 'Carbon';

export default {
  name: 'InvestigationTitle',

  components: { Sorting },

  props: {
    title: {
      type: String,
      default: '',
    },

    hoverTitle: {
      type: String,
      default: '',
    },

    sortby: { type: String, default: '' },
    activeSorting: {
      type: Boolean,
    },

    ascending: {
      type: Boolean,
    },
  },

  emits: ['sort'],

  data() {
    return {
      hover: false,
    };
  },

  computed: {
    ...mapState(['part']),

    isComputedData(): boolean {
      const computedTitles: ComputedData[] = ['Cost', 'Price', 'Lead Time', 'Carbon'];
      return computedTitles.some(computedTitle => this.title.includes(computedTitle));
    },

    isVolumeInvalid(): boolean {
      return this.part?.mesh_checks?.volume_area_trust_status === 'fail';
    },
  },

  methods: {
    sortingActivated() {
      this.$emit('sort', { sortby: this.sortby, ascending: !this.ascending });
    },
  },
};
</script>
